import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Pro1SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M1.828 4.868v5.47a3.75 3.75 0 0 0 2.01 3.322l1.338.7.665.348-.697 1.33-.664-.349-1.338-.7a5.25 5.25 0 0 1-2.814-4.651V3.77l.513-.171c.382-.127.824-.243 1.256-.355l.409-.108c.576-.154 1.126-.317 1.608-.529.484-.212.85-.453 1.092-.735.227-.265.372-.594.372-1.061h1.5c0 .467.145.796.372 1.06.242.283.609.524 1.092.736.482.212 1.033.375 1.608.53l.409.107c.432.112.875.228 1.256.355l.513.171v2.04h-1.5v-.942c-.19-.053-.393-.106-.607-.162l-.458-.12c-.587-.158-1.23-.345-1.824-.605-.584-.257-1.168-.605-1.61-1.113-.444.508-1.028.856-1.612 1.113-.593.26-1.236.447-1.823.604-.16.043-.312.083-.459.12-.214.057-.416.11-.607.163Zm11.73 7.942c-.03.816-.136 1.628-.317 2.428a3.254 3.254 0 0 0 1.799-2.428h-1.481Zm-1.425 2.736a3.299 3.299 0 0 1-.61 0 12.24 12.24 0 0 1-.425-2.736h1.46a12.24 12.24 0 0 1-.425 2.736Zm1.426-3.736a13.233 13.233 0 0 0-.318-2.427 3.254 3.254 0 0 1 1.799 2.428h-1.481Zm-1 0a12.239 12.239 0 0 0-.426-2.735 3.289 3.289 0 0 0-.61 0 12.239 12.239 0 0 0-.425 2.736h1.46Zm-2.462 0c.031-.815.137-1.627.319-2.427a3.254 3.254 0 0 0-1.8 2.428h1.481Zm.319 3.428c-.182-.8-.288-1.612-.319-2.428h-1.48a3.254 3.254 0 0 0 1.799 2.428Zm1.412 1.573a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Pro1SVG;
